import React from "react";
import PliTag from "./../../assets/pli-tag.svg";

export const Pli = ({ className, title, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={PliTag} />
    </div>
  ) : null;
};
